import React, { useEffect, useRef } from 'react';
import './HistoryAndHeritage.css';

const HistoryAndHeritage = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="heritage" className="history-heritage section-padding" ref={sectionRef}>
      <div className="container">
        <div className="heritage-content">
          <div className="heritage-text">
            <div className="text-block fade-in">
              <h2>Four Generations of Excellence</h2>
              <p>
                Since 1924, the Chahine family has dedicated itself to the art of cutlery craftsmanship. 
                What began as a small workshop in the heart of the old city has evolved into a legacy 
                of uncompromising quality and timeless design.
              </p>
            </div>

            <div className="text-block fade-in">
              <h3>Master Craftsmanship</h3>
              <p>
                Each piece in our collection is meticulously handcrafted using techniques passed down 
                through generations. Our artisans combine traditional methods with modern precision, 
                ensuring every knife, fork, and serving piece meets our exacting standards.
              </p>
            </div>

            <div className="text-block fade-in">
              <h3>Heritage Materials</h3>
              <p>
                We source only the finest materials from trusted suppliers worldwide. From Damascus steel 
                to Mediterranean olive wood, each material is chosen for its beauty, durability, and 
                ability to tell a story of its origin.
              </p>
            </div>
          </div>

          <div className="heritage-images">
            <div className="image-stack">
              <div className="heritage-image primary fade-in">
                <img 
                  src="/images/extras/crafts1.webp" 
                  alt="Master craftsman working on cutlery"
                  loading="lazy"
                />
              </div>
              <div className="heritage-image secondary fade-in">
                <img 
                  src="/images/extras/crafts2.webp" 
                  alt="Traditional crafting tools"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="heritage-timeline">
          <div className="timeline-item fade-in">
            <div className="timeline-year">1924</div>
            <div className="timeline-content">
              <h4>The Beginning</h4>
              <p>Grandfather Chahine establishes the first workshop, focusing on traditional cutlery repair and crafting.</p>
            </div>
          </div>

          <div className="timeline-item fade-in">
            <div className="timeline-year">1952</div>
            <div className="timeline-content">
              <h4>Expansion</h4>
              <p>Second generation introduces new techniques and expands the collection to include serving pieces.</p>
            </div>
          </div>

          <div className="timeline-item fade-in">
            <div className="timeline-year">1978</div>
            <div className="timeline-content">
              <h4>Innovation</h4>
              <p>Third generation combines traditional craftsmanship with modern design principles.</p>
            </div>
          </div>

          <div className="timeline-item fade-in">
            <div className="timeline-year">2010</div>
            <div className="timeline-content">
              <h4>Global Recognition</h4>
              <p>Fourth generation brings Chahine Cutlery to international markets while preserving family traditions.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HistoryAndHeritage;